module.exports = __webpack_public_path__ + "img/screenshot-6.c0e6d605.webp";